import clsx from "clsx";
import React from "react";
import { Button as CatalystButton } from "../catalyst/button";

interface ButtonProps {
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "outline" | "ghost" | "danger";
  size?: "sm" | "md" | "lg";
  fullWidth?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = "primary",
  size = "md",
  fullWidth = false,
  onClick,
  disabled = false,
  type = "button",
  className = "",
}) => {
  // Map our variant to Catalyst props
  const getCatalystProps = () => {
    switch (variant) {
      case "primary":
        return { color: "blue" as const };
      case "secondary":
        return { color: "zinc" as const };
      case "outline":
        return { outline: true as const };
      case "ghost":
        return { plain: true as const };
      case "danger":
        return { color: "red" as const };
      default:
        return { color: "blue" as const };
    }
  };

  // Size classes to add on top of Catalyst styles
  const sizeClasses = {
    sm: "text-sm py-1.5 px-3",
    md: "text-base py-2.5 px-4",
    lg: "text-lg py-3.5 px-6",
  };

  // fullWidth prop 또는 className에 w-full이 포함되어 있으면 flex w-full 적용
  const isFullWidth = fullWidth || className.includes("w-full");

  return (
    <CatalystButton
      {...getCatalystProps()}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        sizeClasses[size],
        className.replace(/\bw-full\b/g, ""), // w-full은 제거하고 아래서 flex와 함께 적용
        isFullWidth && "flex w-full"
      )}
    >
      {children}
    </CatalystButton>
  );
};

export default Button;
